import { useState } from 'react';
import { Textarea } from '../../components/ui/textarea';
import { Button } from '../../components/ui/button';
import { Copy, Check, AlertCircle, Minimize2, Maximize2 } from 'lucide-react';
import { toast } from 'sonner';

const JsonFormatterTool = () => {
  const [input, setInput] = useState('');
  const [output, setOutput] = useState('');
  const [error, setError] = useState('');

  const formatJson = () => {
    setError('');
    try {
      const parsed = JSON.parse(input);
      setOutput(JSON.stringify(parsed, null, 2));
      toast.success('JSON formatted successfully');
    } catch (e) {
      setError(e.message);
      setOutput('');
    }
  };

  const minifyJson = () => {
    setError('');
    try {
      const parsed = JSON.parse(input);
      setOutput(JSON.stringify(parsed));
      toast.success('JSON minified successfully');
    } catch (e) {
      setError(e.message);
      setOutput('');
    }
  };

  const handleCopy = () => {
    if (output) {
      navigator.clipboard.writeText(output);
      toast.success('Copied to clipboard');
    }
  };

  const handleClear = () => {
    setInput('');
    setOutput('');
    setError('');
  };

  return (
    <div className="space-y-4" data-testid="json-formatter-tool">
      <div className="flex justify-between items-center">
        <h3 className="font-semibold">JSON Formatter</h3>
        <Button variant="ghost" size="sm" onClick={handleClear}>
          Clear
        </Button>
      </div>

      <div className="space-y-2">
        <label className="text-sm text-muted-foreground">Input JSON</label>
        <Textarea
          placeholder='{"key": "value"}'
          value={input}
          onChange={(e) => setInput(e.target.value)}
          className="min-h-[150px] bg-background/50 font-mono text-sm resize-none"
          data-testid="json-input"
        />
      </div>

      {error && (
        <div className="flex items-center gap-2 text-destructive text-sm p-3 rounded-lg bg-destructive/10 border border-destructive/20" data-testid="json-error">
          <AlertCircle className="w-4 h-4 flex-shrink-0" />
          <span>{error}</span>
        </div>
      )}

      <div className="flex gap-2">
        <Button onClick={formatJson} className="flex-1" data-testid="format-btn">
          <Maximize2 className="w-4 h-4 mr-2" />
          Format
        </Button>
        <Button onClick={minifyJson} variant="outline" className="flex-1" data-testid="minify-btn">
          <Minimize2 className="w-4 h-4 mr-2" />
          Minify
        </Button>
      </div>

      {output && (
        <div className="space-y-2">
          <div className="flex justify-between items-center">
            <label className="text-sm text-muted-foreground">Output</label>
            <Button variant="ghost" size="sm" onClick={handleCopy} data-testid="copy-output-btn">
              <Copy className="w-4 h-4 mr-1" />
              Copy
            </Button>
          </div>
          <div className="relative">
            <pre className="p-4 rounded-lg bg-background/50 border border-border overflow-x-auto text-sm font-mono" data-testid="json-output">
              {output}
            </pre>
          </div>
        </div>
      )}
    </div>
  );
};

export default JsonFormatterTool;
